import firebase from 'src/util/firebase'
import { useUserActions } from './api'
import { useHistory } from 'react-router-dom'
import { setUserSecret } from 'src/util/helper'
import { AssociateError } from 'src/util/associate'

export default function useAssociate () {

  const { associate, sendToken } = useUserActions()
  const history = useHistory()

  const sendFirebaseToken = async (userId: string) => {
    const token = await firebase.retrieveToken()
    if (!token) return null
    await sendToken(token, +userId)
  }

  const associateUser = async (userId: string, urlSecret: string) => {
    try {
      const { email, secret } = await associate(urlSecret, userId)
      setUserSecret(email, secret)
      history.replace('/')
    } catch (err) {
      if (err.status === 400) { throw new AssociateError('Invalid secret') }
      throw new Error()
    }

    try {
      await sendFirebaseToken(userId)
    } catch (err) {
      console.warn('Error sending firebase token')
    }
  }

  return {
    associateUser
  }
}
